import IconsTextNavigation from 'components/global/IconsTextNavigation'
import React, { useState } from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'
import AddItemModal from '../Modals/ItemsToBring/AddItem'
import ItemsToBringModal from 'pages/Events/Views/Common/Modals/ItemsToBring'

const ItemsToBring: React.FC = () => {
  const {
    itemsToBringModal,
    setItemsToBringModal,
    itemsToBring,
    addItemModal,
    setItemsToBring,
    leagueData,
  } = leagueEventStore(store => ({
    itemsToBringModal: store.itemsToBringModal,
    setItemsToBringModal: store.setItemsToBringModal,
    itemsToBring: store.itemsToBring,
    addItemModal: store.addItemModal,
    setItemsToBring: store.setItemsToBring,
    leagueData: store.leagueData,
  }))

  const [openItemsModal, setOpenItemsModal] = useState<boolean>(false)

  return (
    <>
      <div onClick={() => setOpenItemsModal(true)}>
        <IconsTextNavigation
          iconName="ShoppingBagOpen"
          heading="Items to bring"
          isCompleted={itemsToBring.length > 0 ? true : false}
        />
      </div>
      {openItemsModal && (
        <ItemsToBringModal
          openModal={openItemsModal}
          closeModal={setOpenItemsModal}
          prevItems={itemsToBring}
          setPrevItems={setItemsToBring}
          organizationId={leagueData.organizationId}
        />
      )}
      {addItemModal && <AddItemModal />}
    </>
  )
}

export default ItemsToBring
